import { render, staticRenderFns } from "./ButtonRedSecondary.vue?vue&type=template&id=e48ae728&scoped=true"
import script from "./ButtonRedSecondary.vue?vue&type=script&lang=js"
export * from "./ButtonRedSecondary.vue?vue&type=script&lang=js"
import style0 from "./ButtonRedSecondary.vue?vue&type=style&index=0&id=e48ae728&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48ae728",
  null
  
)

export default component.exports